export default class InvalidSceneError extends Error {
    public name = "InvalidSceneError";
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/graphics/layers/invalid-scene-error.ts